import { PRODUCT_CATEGORIES } from 'enums/categories'
import { AdvertItem } from 'context/AdvertContext'

export const desktopAdverts: AdvertItem[] = [
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/car-rental-banner-desktop-61998.webp',
    link: 'https://www.enuygun.com/kampanyalar/arac-kiralama/arac-kiralamada-eylule-ozel-5-000-tlye-varan-indirim/',
    alt: 'enuygun-arac-kiralama',
    width: 1120,
    height: 150,
    category: PRODUCT_CATEGORIES['arac-kiralama'],
  },
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/axess-ucak-desktop-banner-62225.webp',
    link: 'https://www.enuygun.com/kampanyalar/ucak-bileti/axesse-ozel-500-tlye-varan-indirim/',
    alt: 'enuygun-ucak-bileti',
    width: 1120,
    height: 150,
    category: PRODUCT_CATEGORIES['ucak-bileti'],
  },
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/hotel-banner-desktop-62010.webp',
    link: 'https://www.enuygun.com/kampanyalar/otel/otel-rezervasyonlarinda-10-000-tlye-varan-indirimi-kacirma/',
    alt: 'enuygun-otel',
    width: 1120,
    height: 150,
    category: PRODUCT_CATEGORIES['otel'],
  },
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/axess-otobus-desktop-banner-62226.webp',
    link: 'https://www.enuygun.com/kampanyalar/otobus/axesse-ozel-200-tlye-varan-indirim/',
    alt: 'enuygun-otobus-bileti',
    width: 1120,
    height: 150,
    category: PRODUCT_CATEGORIES['otobus-bileti'],
  },
]
export const mobileAdverts: AdvertItem[] = [
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/car-rental-banner-mobile-62040.png',
    link: 'https://www.enuygun.com/kampanyalar/arac-kiralama/arac-kiralamada-eylule-ozel-5-000-tlye-varan-indirim/',
    alt: 'enuygun-arac-kiralama',
    width: 350,
    height: 220,
    category: PRODUCT_CATEGORIES['arac-kiralama'],
  },

  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/axess-ucak-mobile-banner-62228.webp',
    link: 'https://www.enuygun.com/kampanyalar/ucak-bileti/axesse-ozel-500-tlye-varan-indirim/',
    alt: 'enuygun-ucak-bileti',
    width: 350,
    height: 220,
    category: PRODUCT_CATEGORIES['ucak-bileti'],
  },
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/hotel-banner-mobile-62042.png',
    link: 'https://www.enuygun.com/kampanyalar/otel/otel-rezervasyonlarinda-10-000-tlye-varan-indirimi-kacirma/',
    alt: 'enuygun-otel',
    width: 350,
    height: 220,
    category: PRODUCT_CATEGORIES['otel'],
  },
  {
    image: 'https://cdn2.enuygun.com/media/lib/uploads/image/axess-otobus-mobile-banner-62227.webp',
    link: 'https://www.enuygun.com/kampanyalar/otobus/axesse-ozel-200-tlye-varan-indirim/',
    alt: 'enuygun-otobus-bileti',
    width: 350,
    height: 220,
    category: PRODUCT_CATEGORIES['otobus-bileti'],
  },
]
